
import cssToObjectMixin from '~/mixins/cssToObject'
import breakpointMixin from '~/mixins/breakpoints'

export default {
  mixins: [cssToObjectMixin, breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    component() {
      let componentType = null

      if (this.blok.type === 'featured') componentType = 'h1'
      if (this.blok.type === 'h1') componentType = 'h1'
      if (this.blok.type === 'h2') componentType = 'h2'
      if (this.blok.type === 'h3') componentType = 'h3'
      if (this.blok.type === 'h4') componentType = 'h4'
      if (this.blok.type === 'subhead') componentType = 'h2'
      if (this.blok.type === 'paragraph') componentType = 'p'

      // if (this.blok.type === 'text-h1 md:text-featured') componentType = 'h1'
      // if (this.blok.type === 'text-h2 md:text-h1') componentType = 'h1'
      // if (this.blok.type === 'text-h3 md:text-h2') componentType = 'h2'
      // if (this.blok.type === 'text-h3') componentType = 'h3'
      // if (this.blok.type === 'text-h4') componentType = 'h4'
      // if (this.blok.type === 'subhead') componentType = 'h2'
      // if (this.blok.type === 'text-h4') componentType = 'subhead'

      return componentType
    },
    textStyles() {
      const styles = {}

      styles.padding = this.getBreakpointValue(this.blok.padding)
      styles.margin = this.getBreakpointValue(this.blok.margin)
      styles.maxWidth = this.getBreakpointValue(this.blok.maxWidth)
      styles.fontSize = this.getBreakpointValue(this.blok.fontSize)
      styles.lineHeight = this.getBreakpointValue(this.blok.lineHeight)

      return {
        ...styles,
        ...this.parseCSSToObject(this.blok?.styles),
      }
    },
    richTextToHtml() {
      return `
     ${
       this.blok.svg
         ? ` <span class="absolute left-0 top-0">${this.blok.svg}</span>`
         : ''
     }
      ${this.$storyapi.richTextResolver.render(this.blok.richtext)}
      `
    },
  },
}
